import { useAuthMutation } from '#lib/hooks/use-mutation.js';
import { fetchAndParse, jsonHeaders } from '#lib/helpers/fetch.js';

async function fetchOpenAi(data, route, authHeaders) {
    const response = await fetchAndParse(`${API_URL}/p/ai/${route}`, {
        method: 'POST',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify(data)
    });
    return response;
}

export function useAiDescription(options) {
    return useAuthMutation({
        mutationFn: (data, authHeaders) => fetchOpenAi(data, 'description', authHeaders),
        ...options
    });
}

export function useAiImage(options) {
    return useAuthMutation({
        mutationFn: (data, authHeaders) => fetchOpenAi(data, 'image', authHeaders),
        ...options
    });
}
